// extracted by mini-css-extract-plugin
export var svg = "AlmaSymbol-module--svg--1aa2f";
export var wrap = "AlmaSymbol-module--wrap--8af0d composers-module--unButton--f5962";